const AUTH = {
  CUSTOM_CLAIM_NAMESPACE: 'https://www.studywithnewzealand.govt.nz',
  CREATE_USER_SCOPE: 'create:user',
  READ_USER_SCOPE: 'read:user',
  UPDATE_USER_SCOPE: 'update:user',
}

export default AUTH
